import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchAgenticList = createAsyncThunk(
    "fetchAgenticList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/agentic/fetch-agentic-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const AgenticSlice = createSlice({
    name: "AgenticSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAgenticList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAgenticList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(fetchAgenticList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default AgenticSlice.reducer;
